import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
  scrollTo?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href,
  scrollTo = '#precio'
}: CTAButtonProps) {
  // If href is provided, render as an external link
  if (href) {
    return <a href={href} onClick={onClick ? () => onClick() : undefined} target="_blank" rel="noopener noreferrer" className={`
          inline-block text-center cursor-pointer
          w-full sm:w-auto bg-brand-gold-bright hover:bg-yellow-500 
          text-brand-navy font-bold text-lg md:text-xl py-4 px-8 
          rounded-lg shadow-[0_4px_14px_0_rgba(212,175,55,0.39)] 
          hover:shadow-[0_6px_20px_rgba(212,175,55,0.23)] 
          hover:-translate-y-1 transition-all duration-200 
          uppercase tracking-wide font-body no-underline
          ${className}
        `} data-id="element-17">
        {children}
      </a>;
  }
  // Default: scroll to price section
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    if (scrollTo) {
      const target = document.querySelector(scrollTo);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`
        w-full sm:w-auto bg-brand-gold-bright hover:bg-yellow-500 
        text-brand-navy font-bold text-lg md:text-xl py-4 px-8 
        rounded-lg shadow-[0_4px_14px_0_rgba(212,175,55,0.39)] 
        hover:shadow-[0_6px_20px_rgba(212,175,55,0.23)] 
        hover:-translate-y-1 transition-all duration-200 
        uppercase tracking-wide font-body
        ${className}
      `} data-id="element-18">
      {children}
    </button>;
}